<template>
  <div>
    <el-button class="clear" @click="clickClear">クリア</el-button>
    <el-button type="primary" class="register" @click="clickRegister">登録</el-button>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    clickClear () {
      this.$emit('clear')
    },
    clickRegister () {
      this.$emit('register')
    }
  }
}
</script>

<style lang="scss" scoped>
.clear,
.register {
  width: 8em;
}
</style>
